import React from 'react';
import { Text } from '@10d/tend-ui-typography';
import { useTheme, useColor } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';

const Logo = ({ onClick, after, children, before, color = 'gray0' }) => {
    const theme = useTheme();
    // FIXME: Исправить литеральные типы
    const __color = useColor(color);
    return (React.createElement(Root, { theme: theme, className: cn(['tend-ui-logo-root']), "$pointer": !!onClick, onClick: onClick },
        before,
        React.createElement(Text, { color: __color, style: { display: 'block', whiteSpace: 'nowrap' }, strong: true }, children),
        after));
};

export { Logo };
